module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Moneyfront: Invest in \"Direct\" Plans of Mutual fund schemes","icon":"static/images/favicon.png","short_name":"Moneyfront","start_url":"/","background_color":"#277a3c","theme_color":"#77b943","display":"standalone"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
